import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveStateLogInput } from './SaveStateLogInput';
import { SaveStateLogOutput } from './SaveStateLogOutput';

export class SaveStateLogService extends HttpServiceBase {

  handle = (input: SaveStateLogInput): Promise<Result<SaveStateLogOutput> | null> => {
    const promise = this.http.post<Result<SaveStateLogOutput>, SaveStateLogInput>(`${this.baseUrlSislogApi}/v2/state-log`, input);
    return promise;
  }
}